
import React, { useEffect, useState } from 'react'

import useTranslation from '@/Hooks/UseTranslation'

import ContentBlock from '../../components/ContentBlock'
import CommentInput from '../../components/CommentInput'
import CommentsList from '../../components/CommentsList'

interface Props {
  taskId: string // TODO: remove this and use itemOpened instead
  items: any[]
}

const Comments = ({ taskId, items }: Props) => {

  const { t } = useTranslation()

  const [ comments, setComments ] = useState(items)

  useEffect(() => {

    setComments(items)
  }, [ items ])

  const onCommentsUpdated = (comments: any[]) => {

    setComments(comments)
  }

  return (
    <ContentBlock
      title={t('COMMENTS_SECTION:Title')}
      collapsable
      isCollapsed={!comments.length}
    >
      <CommentInput taskId={taskId} onCommentsUpdated={onCommentsUpdated} />
      <CommentsList items={comments} />
    </ContentBlock>
  )
}

export default Comments